import { render, staticRenderFns } from "./dialogDistribution.vue?vue&type=template&id=b91dd828&scoped=true&"
import script from "./dialogDistribution.vue?vue&type=script&lang=js&"
export * from "./dialogDistribution.vue?vue&type=script&lang=js&"
import style0 from "./dialogDistribution.vue?vue&type=style&index=0&id=b91dd828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91dd828",
  null
  
)

export default component.exports